import React from 'react';
import { cn } from '@/lib/cn';
import { MaskedText } from './MaskedText';

export interface DataCellProps extends React.HTMLAttributes<HTMLDivElement> {
  /** The icon component to display (24px recommended) */
  icon: React.ReactNode;
  /** The value to display (e.g., percentage, text) */
  value: string;
  /** The description text below the value */
  description: string;
  /** Whether to mask the value */
  isMasked?: boolean;
}

/**
 * DataCell - A reusable component for displaying icon, value, and description
 * Used in sections like "Renter recommendations" and "Rents and deposits"
 */
export default function DataCell({
  icon,
  value,
  description,
  className,
  isMasked = false,
  ...props
}: DataCellProps) {
  return (
    <div
      className={cn(
        'flex items-center gap-4 px-2 py-3 rounded-xl',
        'basis-0 grow min-w-0',
        className,
      )}
      {...props}
    >
      {/* Icon - 24px */}
      <div className="flex-shrink-0 w-6 h-6">{icon}</div>

      {/* Text Content */}
      <div className="flex flex-col gap-1 flex-1 min-w-0">
        {/* Value - Body 1 High emphasis */}
        <div className="text-body-1-high text-primary">
          {isMasked ? <MaskedText className="w-16 h-4" /> : value}
        </div>

        {/* Description - Caption */}
        <p className="text-caption text-secondary">{description}</p>
      </div>
    </div>
  );
}
